import React, { useState } from 'react';
import './SignupWindow.css';
import popuplogo from '../asset/logo/popuplogo.png'
import logo from '../asset/logo/logo192.png'
import { CONTENT } from '../config/landingPageContent';

const apiUrl = process.env.REACT_APP_API_URL;

const PopupWindow = ({ onClose, variant = 'default' }) => {
    const content = CONTENT[variant] || CONTENT.default;
    const [contactMethod] = useState('email');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [countryCode, setCountryCode] = useState('+1');
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);

   

    const validateInput = () => {
        if (contactMethod === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                setError("Please include an '@' in the email address. '" + email + "' is missing an '@'.");
                return false;
            }
        } else {
            // Phone number validation
            const phoneRegex = /^\d{10,14}$/;
            if (!phoneRegex.test(phoneNumber)) {
                setError("Please enter a valid phone number (10-14 digits).");
                return false;
            }
        }
        setError(null);
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateInput()) {
            return;
        }

        const data =
            contactMethod === 'email'
                ? { "email": email }
                : { "phone": `${countryCode}${phoneNumber}` };
        try {
            const response = await fetch(`${apiUrl}/marketing/new_sign_up`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Failed to record signup');
            }
            const result = await response.json();
            setSuccessMessage(result.message);
            onClose();
        } catch (error) {
            console.log(error);
            setError(error.message);
        }
    };

    return (
        <div className="popup-overlay">
            <div className="popup-container">
                <button onClick={onClose} className="close-button">×</button>
                <div className="popup-content">
                    <div className="image-section">
                        <img src={popuplogo} alt={content.demo.copilot} className="product-image" />
                    </div>
                    <div className="form-section">
                        <img src={logo} className="logo" alt='logo' />
                        <h2>Sign up today to get</h2>
                        <p className="offer-large">15% off</p>
                        <p className="offer-description">{content.popup.description}</p>
                        <form onSubmit={handleSubmit}>
                            {contactMethod === 'email' ? (
                                <div className="input-group">
                                    <label htmlFor="email">Email address</label>
                                    <input
                                        type="email"
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        placeholder="Enter your email address"
                                    />
                                </div>
                            ) : (
                                <div className="input-group">
                                    <label htmlFor="phone">Phone number</label>
                                    <div className="phone-input-container">
                                        <select
                                            value={countryCode}
                                            onChange={(e) => setCountryCode(e.target.value)}
                                            className="country-code-select"
                                        >
                                            <option value="+1">+1 (US)</option>
                                            <option value="+44">+44 (UK)</option>
                                            <option value="+86">+86 (CN)</option>
                                            <option value="+61">+61 (AU)</option>
                                            <option value="+65">+65 (SG)</option>
                                            <option value="+49">+49 (DE)</option>
                                        </select>
                                        <input
                                            type="tel"
                                            id="phone"
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                            required
                                            placeholder="Enter your phone number"
                                        />
                                    </div>
                                </div>
                            )}
                            {error && <p className="error-message">{error}</p>}
                            <div className="divider">
                                <span className="divider-line"></span>
                                <span className="divider-line"></span>
                            </div>

                            <button type="submit" className="submit-button">Unlock Offer</button>
                        </form>
                        {successMessage && <p className="success-message">{successMessage}</p>}
                        <button onClick={onClose} className="no-thanks">No Thanks</button>
                        <p className="terms">*PromoCode will be sent through Email</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopupWindow;
